export const withGuideImageReferences = (variables, references) => (references?.length
    ? { ...variables, references: JSON.stringify(references) }
    : variables);
//# sourceMappingURL=GuideImageTransport.js.map